import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { InvitationCodeGateway } from 'src/app/application/gateway/InvitationCodeGateway';
import { InvitationCodeCreate } from 'src/app/domain/models/InvitationCode';
import { Lang } from 'src/app/domain/models/Language';
import { BasicUser } from 'src/app/domain/models/User';
import { ErrorMessageUtil } from 'src/app/ui/util/error-message-util';

@Component({
  selector: 'app-admin-invitation-code',
  templateUrl: './admin-invitation-code.component.html',
  styleUrls: ['./admin-invitation-code.component.css']
})
export class AdminInvitationCodeComponent {

  @Output() closeDialog = new EventEmitter();

  email: string = '';
  fullname: string = '';
  loading: boolean = false
  submit: boolean = false
  langs: Lang[] = []
  lang: Lang | undefined
  profile: BasicUser | undefined

  formGroup: FormGroup = this._formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    fullname: ['', Validators.required],
    language: ['', Validators.required]
  })

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _invitationCodeService: InvitationCodeGateway,
    private readonly _authService: AuthGateway,
    private readonly _messageService: MessageService,
    public readonly translate: TranslateService
  ) {}

  ngOnInit() {
    this.langs = [
      {
        label: 'English',
        lang: 'en',
        icon: 'GB.png'
      },
      {
        label: 'Español',
        lang: 'es',
        icon: 'ES.png'
      }
    ]

    this.lang = this.langs.find(x => x.lang == 'en')
    this.profile = this._authService.getUser()
  }

  switchLang = () => {
    this.lang = this.langs.find(x => x.lang == this.formGroup.controls['language'].value)
  }

  generateCode() {
    this.submit = true
    if (this.formGroup.valid) {
      let request: InvitationCodeCreate = {
        email: this.email,
        fullname: this.fullname,
        language: this.lang?.lang ?? "en",
        isRequest: false
      }

      this.sendGenerationCode(request)
    }
    else {
      this.loading = false
    }
  }

  sendGenerationCode(request: InvitationCodeCreate) {
    this.loading = true
    this._invitationCodeService.create(request).subscribe({
      next: () => {
        this._messageService.add({ 
          severity: 'success', 
          summary: this.translate.instant('InvitationCodePage.SuccessfulActionTitle'), 
          detail: this.translate.instant('InvitationCodePage.SuccessGeneratedCodeText')
        })
        this.submit = false
        this.loading = false
        this.cancel()
      },
      error: (e) => {
        this.submit = false
        let errorMessage = ''
        switch(this.profile?.lang) {
          case 'es':
            errorMessage = e.error.messageEs
            break
          case 'en':
            errorMessage = e.error.messageEn
            break
        }
        if(e.status === 500){
          this._messageService.add({ 
            severity: 'error', 
            summary: this.translate.instant('InvitationCodePage.FailedActionTitle'), 
            detail: this.translate.instant('InvitationCodePage.FailedGeneratingCodeText') 
          })
        }
        else {
          this._messageService.add({ 
            severity: 'error', 
            summary: this.translate.instant('InvitationCodePage.FailedActionTitle'), 
            detail: errorMessage 
          });
        }
        this.loading = false
      }
    })
  }

  getErrorMessage(fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(this.formGroup, this.translate, fieldName)
  }

  cancel(): void {
    this.closeDialog.emit()
  }
}
